import React from 'react';
export function Guarantee() {
  return <section className="w-full bg-white px-4 py-10 text-gray-900 text-base leading-6" style={{
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-169">
      <div className="mx-auto max-w-3xl text-center" data-id="element-170">

        {/* ÍCONO */}
        <div className="mb-4 text-[64px] leading-[64px]" data-id="element-171">🛡️</div>

        {/* TÍTULO */}
        <h2 className="text-3xl font-black leading-10 text-orange-500 m-0 mb-4" data-id="element-172">
          GARANTÍA ANTI PANTALLA™ — 7 DÍAS
        </h2>

        {/* CAJA GARANTÍA */}
        <div className="mb-6 rounded-xl p-6 border-2 border-orange-400 shadow-sm" style={{
        backgroundColor: 'rgb(255, 247, 237)'
      }} data-id="element-173">
          <p className="text-base leading-[24px] text-gray-900 m-0 mb-3" data-id="element-174">
            Descargás los 6 tomos. Revisás los 6 bonos. Los imprimís y los usás
            con tu hijo si querés.
          </p>
          <p className="text-base leading-[24px] text-gray-900 m-0 mb-4" data-id="element-175">
            Si en 7 días no es lo que esperabas:
          </p>
          <p className="text-2xl font-black text-orange-500 m-0 mb-3" data-id="element-176">
            Te devolvemos el 100%.
          </p>
          <p className="text-lg font-bold text-gray-900 m-0" data-id="element-177">
            Sin preguntas. Sin formularios. Sin drama.
          </p>
        </div>

        {/* TEXTO DE CONFIANZA */}
        <p className="text-xs leading-[20px] text-gray-500 m-0" data-id="element-178">
          La confianza que tenemos en el Megapack Anti Pantalla nos permite
          hacer esa promesa sin dudar.
          <br data-id="element-179" />
          Más de 1.200 mamás de todo el país ya lo saben.
          <br data-id="element-180" />
          La tasa de devoluciones es menor al 1%.
        </p>

      </div>
    </section>;
}